import * as React from "react"
import type { SVGProps } from "react"
const SvgDiscordLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 256 256"
    {...props}
  >
    <path
      fill="currentColor"
      strokeMiterlimit={10}
      d="M54.657 19.077S63 28.74 63 46.146v3.65s-10.536 6.866-13.747 6.866l-3.115-4.529c1.936-.867 4.577-2.372 4.577-2.372l-.965-.747s-6.173 2.86-13.749 2.86-13.749-2.86-13.749-2.86l-.965.747s2.641 1.505 4.577 2.372l-3.115 4.529C19.536 56.662 9 49.796 9 49.796v-3.65c0-17.406 8.343-27.069 8.343-27.069s5.707-2.762 10.977-3.489l1.635 3.1s2.599-.602 6.045-.602 6.045.602 6.045.602l1.635-3.1c5.27.727 10.977 3.489 10.977 3.489M27.01 43.603c2.656 0 4.808-2.418 4.808-5.401s-2.153-5.401-4.808-5.401-4.808 2.418-4.808 5.401 2.152 5.401 4.808 5.401m17.98 0c2.656 0 4.808-2.418 4.808-5.401s-2.153-5.401-4.808-5.401c-2.656 0-4.808 2.418-4.808 5.401s2.152 5.401 4.808 5.401"
      fontFamily="none"
      fontSize="none"
      fontWeight="none"
      style={{
        mixBlendMode: "normal",
      }}
      textAnchor="none"
      transform="matrix(4.65778 0 0 4.65778 -39.68 -39.68)"
    />
  </svg>
)
export default SvgDiscordLogo
